import { getParams } from '../server/controllers/patternUtils';
import { isEmpty } from 'Helpers/objects';

/**
 * To get legacy params which are bound with RR3 implementation
 * @param legacyPath
 * @param location
 * @returns {{}}
 */

const cacheLegacyParam = {};

function getLegacyParams(legacyPath, location) {
    let legacyParams = {};

    if (legacyPath) {
        if (cacheLegacyParam[location.pathname]) {
            return cacheLegacyParam[location.pathname];
        }
        if (Array.isArray(legacyPath)) {
            legacyPath.every(regex => {
                legacyParams = getParams(regex, location.pathname);
                if (!isEmpty(legacyParams)) {
                    legacyParams.matchedLegacyRoute = regex;
                    return false;
                }
                return true;
            }
            );
        }
        else {
            legacyParams = getParams(legacyPath, location.pathname);
            if (!isEmpty(legacyParams)) {
                legacyParams.matchedLegacyRoute = legacyPath;
            }
        }
        cacheLegacyParam[location.pathname] = legacyParams;
    }

    return legacyParams;
}

export default getLegacyParams;
